import React from 'react';
import { PageHeader } from './MassTimes';
import ParishCalendar from '../components/ParishCalendar';

const ParishCalendarPage = () => {
  return (
    <>
      <PageHeader
        eyebrow="What's Coming Up"
        title="Parish Calendar"
        subtitle="Masses, sacraments, meetings, socials, and special liturgies — all in one place. Subscribe or view in Google Calendar to stay up to date."
      />
      <div className="pt-4">
        <ParishCalendar />
      </div>
    </>
  );
};

export default ParishCalendarPage;
